<template>

	<l-map ref="map" class="map"
		@update:zoom="setZoom"
		@click="onClick($event)"
		:bounds="bounds"
		:maxZoom="zoomMax"
		:minZoom="zoomMin"
		:options="{
			zoomControl: false,
		}"
	>
		<l-tile-layer
			:url='tileUrl'
			:attribution='"<span>" + attribution.join("</span><span>") + "</span>"'
		></l-tile-layer>


		<l-marker
			:lat-lng="marker.coords"
			@add="onAddMarker($event, marker.id)"
			v-for="marker in markers"
			:key="marker.id"
			@click="sendForward($event.target)"
		>
			<l-icon
				:className="'n-icon n-icon-' + marker.p"
				:x-icon-anchor="iconAnchor"
			>
				<div class="picto">
					<picto-train class="picto-train" v-if="marker.p === 'transport-train'"/>
					<picto-camion class="picto-camion" v-else-if="marker.p === 'transport-camion'"/>
					<picto-baril class="picto-baril" v-else-if="!marker.p.match(/^transport/)"/>
					<picto-pointeur class="pointeur"/>

				</div>
			</l-icon>

			<l-popup
				:options="popupOptions"
				@popupclose="sendBackward()"
			>

				<div class="btn-close" @click="closePopup()"><close-icon/></div>

				<div class="popup-wrapper" :class="'popup-'+marker.t">
					<div class="popup-meta">

						<div class="popup-title">
							<div>
								<span class="name">
									{{ marker.n }}
								</span>
							</div>
							<div>
								<small class="type">

									<span v-html="texts.nomenclature[marker.t]"></span>

									<template v-if="marker.e">
										({{marker.e}})
									</template>
								</small>
							</div>
						</div>



						<template v-if="selectedVille" class="place-info">
							<div class="location-wrapper">
								<span class="location" v-html="texts.lieu.replace(/%distance/, marker.distance).replace(/%ville/, selectedVille.nom)">
								</span>
							</div>

							<div>
								<div class="has-icon is-link" @click="gotoHome()">
									<div class="icon">
										<picto-retour class="picto-retour"/>
									</div>
									<div>
										<span class="popup-link" v-html="texts.back"></span>
									</div>
								</div>
							</div>
						</template>


					</div>

					<div class="popup-content">
						<div v-if="marker.i" class="popup-img">

							<a v-if="marker.l" :href="marker.l" target="_blank">
								<img :src="marker.i"/>
							</a>

							<img v-else :src="marker.i"/>

						</div>

						<p v-for="(p, index) of marker.d" :key="index" v-html="p">
						</p>
					</div>

					<div v-if="marker.s" class="has-icon is-link">
						<div class="icon">
							<picto-plus class="picto-more"/>
						</div>
						<div>
							<a class="popup-link"
								:href="marker.s"
								target="_blank"
								v-html="texts.source + (marker.o ? ' ' + marker.o : '')"
								></a>
						</div>
					</div>



				</div>
			</l-popup>
		</l-marker>



		<l-marker v-if="selectedVille"
			ref="home"
			:lat-lng="selectedVille.coords"
			:options="{
				zIndexOffset: 9999
			}"
			@click="sendForward($event.target)"
		>
			<l-icon
				className="n-icon n-icon-home"
				:x-icon-anchor="iconAnchor"
			>
				<div class="picto">
					<picto-maison class="picto-maison"/>
					<picto-pointeur class="pointeur"/>
				</div>
			</l-icon>

			<l-popup
				:options="homePopupOptions"
				@popupclose="sendBackward()"
			>
				<div class="btn-close" @click="closePopup()"><close-icon/></div>

				<h3 class="popup-name">{{ selectedVille.nom }}</h3>

				<div class="popup-content" v-if="selectedVille.list.length">
					<p class="is-size-6" v-html="texts.distance.replace(/%distance/, selectedVille.minimum_distance)">
					</p>

					<ul class="popup-list">
						<li
							v-for="l in selectedVille.list"
							:key="l.id"

						>
							<span class="popup-link" @click="gotoPlace(l.id)">

							<template>
								<b>{{ l.n }}</b> - <span v-html="texts.nomenclature[l.t]"></span>
							</template>
							</span>

							<span class="distance">{{ l.distance }}</span>

						</li>
					</ul>

<!--
					<div class="popup-act">
						<p class="is-size-6" v-for="(p, index) of texts.preCta" :key="index" v-html="p"></p>
						<p class="text-center">
							<span class="button-cta" v-html="texts.ctaLabel" @click="showCta()"></span>
						</p>
					</div>
-->

				</div>


			</l-popup>
		</l-marker>


		<svg class="svg-filters" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10 10">
			<defs>
				<filter id="filter-blur">
					<feDropShadow stdDeviation=".3" dx="0" dy="0"></feDropShadow>
				</filter>
			</defs>
		</svg>
	</l-map>
</template>

<script>

import { latLng, latLngBounds } from 'leaflet';
import places from '@places';
//import deepSort from 'deep-sort';
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet'

import PictoPointeur from './icons/pointeur-2-vectoriser.svg'
import PictoPlus from './icons/plus.svg'
import PictoRetour from './icons/retour.svg'
import PictoTrain from './icons/train.svg'
import PictoBaril from './icons/baril.svg'
import PictoCamion from './icons/camion.svg'
import PictoMaison from './icons/maison.svg'
import CloseIcon from './icons/fermer.svg';

import texts from '@texts/popups.json'
import footer from "@texts/footer.json"
import mapData from '@texts/map-data.json'

const assign = require('es6-object-assign').assign;
const floor = Math.floor;
const min = Math.min;

const PALLIER = 50
const OFFSET_POINT = 76 // pixels depuis le bord bottom pour l'affichage du point lors du choix de la ville
const PREFERED_ZOOM = 10

export default {
	name: 'Map',
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		LIcon,
		PictoPointeur,
		PictoPlus,
		PictoRetour,
		PictoCamion,
		PictoMaison,
		PictoBaril,
		PictoTrain,
		CloseIcon,
	},
	props: {
		bbox: {
			type: Array,
			default: function() {
				return []
			}
		}
	},
	data() {

		return {
			activeMarker: 0,
			markers: [],
			iconAnchor: [6, 6],
			selectedVille: false,
			bounds: latLngBounds(),
			homeBounds: [],
			zoomLevel: 6,
			selectedPlace: -1,
			offsetTop: 110,
			texts: texts,
			attribution: footer,
			tileUrl: mapData.tileUrl,
			zoomMax: mapData.zoomMax,
			zoomMin: mapData.zoomMin,
		};
	},
	computed: {
		popupMaxHeight() {
			let zoom = this.zoomLevel
			if (zoom > 11)
				zoom = 11

			let h = window.innerHeight
				- this.offsetTop
				- zoom
				- OFFSET_POINT
				/*
				- (10.28 * zoom)
				- 8
				- (3 * 10.28)
				*/
			if (!h) h = 500

			return h
		},
		popupOptions() {
			return {
				maxWidth: "",
				maxHeight: this.popupMaxHeight,
				className: "popup",
				pane: "markerPane",
				autoPan: true,
				autoPanPaddingTopLeft: [5, this.offsetTop + 5],
				autoPanPaddingBottomRight: [50, 5]
			}
		},
		boundsOptions() {
			return {
				autoPanPaddingTopLeft: [5, this.offsetTop + 5],
				autoPanPaddingBottomRight: [50, 5],
				animate: false,
				duration: 0,
			}
		},
		homePopupOptions() {
			return assign({}, this.popupOptions, {
				className: 'popup popup-home',
			})
		}
	},
	methods: {
		showCta() {
			this.$emit('cta')
		},
		sendBackward() {
			this.activeMarker.setZIndexOffset(-20000)
		},
		sendForward(marker) {
			if (this.activeMarker)
				this.sendBackward()

			marker.setZIndexOffset(20000)

			this.activeMarker = marker
		},
		setBoundingTop(value) {
			this.offsetTop = value;
		},
		previousPlace() {
			let sp = this.selectedPlace
			const list = this.selectedVille.list

			for (let i = 0, l = list.length; i < l; i++) {
				if (sp === list[i].id) {
					if (i === 0)
						this.gotoPlace(list[l - 1].id)
					else
						this.gotoPlace(list[i - 1].id)

					return
				}
			}
		},
		nextPlace() {
			let sp = this.selectedPlace
			const list = this.selectedVille.list

			for (let i = 0, l = list.length; i < l; i++) {
				if (sp === list[i].id) {
					if (i === l - 1)
						this.gotoPlace(list[0].id)
					else
						this.gotoPlace(list[i + 1].id)

					return
				}
			}
		},
		gotoPlace(id) {
			this.selectedPlace = id

			this.$refs.map.mapObject.setView(
				places[id].coords,
				this.zoomLevel,
				this.boundsOptions
			)

			this.$nextTick(() => places[id].marker.fire('click'))
		},
		gotoHome() {
			const home = this.$refs.home.mapObject
			home.closePopup()
			this.$refs.map.mapObject.fitBounds(
				latLngBounds(this.homeBounds),
				this.boundsOptions
			)

			this.$nextTick(() => home.fire('click'))

		},
		zoomCommand(action) {
			switch (action) {
				case 'in':
					this.$refs.map.mapObject.zoomIn();
					break;

				case 'out':
					this.$refs.map.mapObject.zoomOut();
					break;
			}
		},
		closePopup() {
			this.$refs.map.mapObject.closePopup()
		},
		searchPlaces(latlng) {

			const counts = {}

			for (let i in places) {
				const place = places[i]
				const dist = floor(latlng.distanceTo(place.coords) / 1000)

				place.distance = dist

				const idx = floor(dist / PALLIER)

				if (typeof counts[idx] === "undefined")
					counts[idx] = []

				counts[idx].push(place)

			}

			let list = []
			let i = 0
			let bounds = [latlng]


			while ( !(i > 1 && list.length >= 3) ) {
				if (typeof counts[i] !== "undefined") {
					const c = counts[i]
					c.map((item) => bounds.push(item.coords))
					list.push(...c)
				}
				i++
			}

			this.homeBounds = bounds

			return {
				minimumDistance: i * PALLIER,
				list: list
			}
		},
		onClick(e) {
			this.$emit('click', e)
		},
		isFound(id) {
			if (!this.selectedVille)
				return false


			for (let item of this.selectedVille.list) {
				if (item.id === id)
					return true
			}

			return false
		},
		addVille(ville) {
			let v = assign({}, ville)
			let coords = v.coords
			const res = this.searchPlaces(coords)

			v.list = res.list
			v.minimum_distance = res.minimumDistance

			this.selectedVille = v;

			this.$nextTick(() => this.gotoHome())
		},
		onAddMarker(e, id) {
			places[id].marker = e.target
		},
		setZoom() {
			const map = this.$refs.map
			map.$el.classList.remove('zoom-' + this.zoomLevel);
			this.zoomLevel = map.mapObject.getZoom();
			map.$el.classList.add('zoom-' + this.zoomLevel);
		},
		createMap() {
			const map = this.$refs.map.mapObject

			let has_bounds = false
			if (this.bbox.length === 4) {
				has_bounds = true
				let lat1 = parseFloat(this.bbox[0])
				let lng1 = parseFloat(this.bbox[1])

				if (!isNaN(lat1) && !isNaN(lng1)) {
					this.bounds.extend([lat1, lng1])
				}
				else {
					has_bounds = false
				}

				let lat2 = parseFloat(this.bbox[2])
				let lng2 = parseFloat(this.bbox[3])

				if (!isNaN(lat2) && !isNaN(lng2)) {
					this.bounds.extend([lat2, lng2])
				}
				else {
					has_bounds = false
				}
			}

			for (let i in places) {
				let place = places[i];

				let coords = latLng(place.c[0], place.c[1]);

				if (!has_bounds) {
					this.bounds.extend(coords);
				}

				place.coords = coords;
				place.id = i;
				this.markers.push(place);
			}

			map.fitBounds(this.bounds, this.boundsOptions)

		},
	},
	mounted() {
		this.$nextTick(() => {
			this.createMap()
		})
	},
}
</script>

<style scoped lang="scss">
@import "~leaflet/dist/leaflet.css";

.map {
	z-index: 500;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;

}

.hidden {
	display: none;

}


</style>

<style lang="scss">


.popup-home {
	.leaflet-fade-anim & {
		transition: opacity 1.2s;
	}

}


@for $i from 1 through 20  {
	$s: 10.28 * $i - 3 * 5.28;

	.zoom-#{$i} {

		.popup.leaflet-popup {
			margin-bottom: #{ $s }px;
		}

		.picto  {
			width: #{ $s + 8 }px;
			height: #{ $s + 8 }px;
		}

	}
}


.popup {
	z-index: 10000;
	box-shadow: 0 0 4px 0 rgba(0, 0, 0, .25);
	max-width: 500px;
	width: 86vw;
	margin-top: 6px;



	&.leaflet-popup {
		margin: 0;
	}

	.leaflet-popup-close-button {
		//margin-right: 10px;
		//margin-top: 5px;
		right: 1rem !important;
		display: none;
	}

	.btn-close {
		position: absolute;
		top: 20px;
		right: 20px;

		width: 12px;
		height: 12px;
		cursor: pointer;

		> * {
			fill: lighten($noir, 40%);
			width: 100%;
		}
	}

	.popup-content {
//		padding: 0 1rem;
		flex-grow: 1;
		margin-bottom: 10px;
	}

	.popup-meta {
		padding: 0 0 10px;
		display: flex;
		flex-direction: column;

		.name,
		.type,
		.location {
			padding: 2px;
		}

		.name {
			@extend %font-site-name;
		}

		.type {
			@extend %font-site-type;
		}

		.location-wrapper {
			margin-bottom: 10px;
		}

		.location {
			@extend %font-city-distance;
		}


	}

	.popup-link {
		@extend %font-link;
//		text-decoration: underline;
	}


	.popup-name {
		@extend %font-city-name;
		padding: 3px 6px;
		margin-right: 32px;
		display: inline-block;
		margin-bottom: .75em;
	}

	.popup-navigation {
		display: flex;
		justify-content: space-between;
		padding-bottom: 1rem;

	}

	.popup-arrow {
		font-size: 1.5rem;
		cursor: pointer;
		padding: 0 .5rem;
		align-self: center;
		display: none;
	}

	.has-navigation .popup-arrow {
		display: block;
	}

	.popup-title {
		flex-grow: 1;
	}

	.leaflet-popup-content-wrapper {
		border-radius: 0;
		box-shadow: none;
		padding: 0;
	}

	.leaflet-popup-scrolled {
		border: none;
		overflow-y: auto;
		overflow-x: hidden;

		> * {
			margin-bottom: 20px;
		}
	}

	.leaflet-popup-content {
		margin: 0;
		width: 100% !important;
		padding: 20px;
	}

	.leaflet-popup-tip-container {
		display: none;
		width: 40px;
		height: 80px;
		position: absolute;
		left: 50%;
		//transform: translateX(50%);
		overflow: visible;
		pointer-events: none;

		.leaflet-popup-tip {
			width: 18x;
			height: 160px;
			border: 9px solid transparent;
			box-shadow: none;
			transform: rotate(10deg);
			border-top: 80px solid #fff;
			padding: 0;
			background: transparent;

		}

	}

	ul {
		margin-top: 1rem;
		margin-left: 1rem;
		padding-bottom: 1rem
	}

	li {
		list-style-type: disc;
		cursor: pointer;
	}

	.place-info {
		margin-left: 1rem;
		margin-right: 1rem;
	}

	.distance {
		padding-left: .5rem;

		&:before {
			content: "(";
		}

		&:after {
			content: "Km)";
		}
	}

	.popup-act {
		text-align: center;
		padding-top: .5rem;

		.button-cta {
			@extend .button;
			@extend %font-cta-small;
			box-shadow: 0 0 2px 0 rgba(0, 0, 0, .4);
			background-color: $jaune;
			padding: 8px 20px;
			margin-top: 10px;
		}
	}
}



.picto {
	position: absolute;
	bottom: 0;
	left: 50%;
	//width: 100%;
	transform: translateX(-50%);
	pointer-events: none;

	> * {
		pointer-events: all;
	}

	.pointeur {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;

		> path {
			stroke: #fff;
			stroke-width: .5px;
			fill: $rouge;

			.n-icon-home & {
				fill: $jaune;
			}

			.n-icon-transport-train & {
				fill: $train;
			}

			.n-icon-transport-camion & {
				fill: $camion;
			}

		}
	}

	.picto-camion,
	.picto-baril,
	.picto-train,
	.picto-maison {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
	}

	.picto-train {
		width: 46%;
		top: 18%;
	}

	.picto-camion {
		width: 40%;
		top: 26%;
		left: 51%;
	}

	.picto-baril {
		top: 20%;
		width: 26%;
	}

	.picto-maison {
		top : 13%;
		width: 46%;
		fill: $noir;
	}
}



.leaflet-tile-container img {
    box-shadow: 0 0 1px rgba(150, 150, 0, 0.05);
}

.picto-more,
.picto-retour {
	fill: $bleu;
	height: 12px;
	max-width: 1rem;
	margin-right: 5px;
}

.has-icon {
	display: flex;
	align-items: center;

	.icon {
		vertical-align: middle;
	}
}

.is-link {
	cursor: pointer;

	.popup-link {
		border-bottom: 1px solid lighten($bleu, 40%);
	}
}


.leaflet-control-attribution {
	@extend %font-attributions;
	width: 100%;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	padding: 0 2rem;

	> a,
	> * {
		padding-right: .25em;
	}

	> span {
		&:after {
			content: "|";
			padding-left: .25em;
		}

		&:first-of-type {
			padding-left: .25em;
		}

		&:last-child {
			&:after {
				display: none;
			}
		}

	}
}

.leaflet-bottom.leaflet-right {
	width: 100%;
}

.picto-baril,
.picto-maison,
.picto-camion,
.picto-train {
	fill: $blanc;
	max-width: 100%;
}

.svg-filters {
visibility: hidden;
pointer-events: none;
}



.popup-img {
	margin-bottom: 1rem;

	img {
		max-width: 100%;
		width: 100%;
		border: none;
	}
}

</style>
